import React, {useEffect} from 'react';
import {ActionModal, useErrorHandler, ErrorModal} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useCategoryById} from '../../../../entities';

interface DeleteCategoryModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  categoryId: string;
}

export const DeleteCategoryModal = ({open, setOpen, categoryId}: DeleteCategoryModalProps) => {
  const {deleteCategoryMutation} = useCategoryById(categoryId);

  const {
    isErrorModalOpen,
    errorInfo,
    handleError,
    handleClose
  } = useErrorHandler({
    resourceName: 'Удаление категории',
    title: 'Ошибка при удалении категории',
  });

  useEffect(() => {
    if (deleteCategoryMutation.error) {
      handleError(deleteCategoryMutation.error as unknown as ApiError);
    }
  }, [deleteCategoryMutation.error, handleError]);

  const handleSubmit = () => {
    deleteCategoryMutation.mutate(categoryId, {
      onSuccess: () => {
        setOpen(false);
      },
    });
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={deleteCategoryMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление категории'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
        Вы уверены, что хотите удалить эту категорию? Обратите внимание, что это действие безвозвратное
        </Text>
      </ActionModal>
      <ErrorModal
        open={isErrorModalOpen}
        onClose={handleClose}
        title={errorInfo.title}
        message={errorInfo.message}
      />
    </>
  );
}; 